import React from "react";
import {
  Table,
  TableProps,
  TableThemeEnum,
} from "../../../../../../components/core/Table/Table";

interface AddCoursesFormationCMProps<T extends object> extends TableProps<T> {
  loading: boolean;
  emptyText: string;
}

export const TableFormationCM = <T extends object>({
  loading,
  emptyText,
  ...props
}: AddCoursesFormationCMProps<T>) => {
  return (
    <Table
      theme={TableThemeEnum.DARK}
      {...props}
      loading={loading}
      pagination={
        props.pagination && {
          current: props.pagination.current + 1,
          onChange: (pageNumber) => props.pagination?.onChange(pageNumber - 1),
          total: props.pagination.total,
          pageSize: props.pagination.pageSize,
        }
      }
      expandable={props.expandable}
      emptyText={emptyText}
    />
  );
};
